import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";
import { BankMoviment } from "../../../../models/financial/banking-operation/bank-moviment";

@Injectable()
export class BankMovimentListProvider implements Resolve<any> {
    bankMoviment: BankMoviment[];
    bankMovimentEdit: BankMoviment;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.bankMovimentEdit = this.state?.currentBankMoviment;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.fieldSort = "historic";
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "historic";
        }
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    get(id: number): Observable<BankMoviment> {
        if (!id) {
            return null;
        }
        return this.gw.get("bankMoviment/:id", { id: id });
    }

    get currentBankMoviment(): BankMoviment {
        return this.bankMovimentEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("bankMoviment/").subscribe({
                next: (res: HttpResponse<any>) => {
                    this.bankMoviment = res.body;
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("bankMoviment/search/transfer", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.bankMoviment, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.bankMoviment = res.body.content;
                        this.onDataChanged.next(this.bankMoviment);
                    } else {
                        this.bankMoviment = res.body.content;
                    }
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }
    /*
         getPage(pageOptions: PageOptions): Promise<any> {
            return new Promise((resolve, reject) => {
                this.gw.post("bankMoviment/search", pageOptions).subscribe({
                    next: (res: HttpResponse<any>) => {
                        if (
                            !CwUtils.compare(this.bankMoviment, res.body.content) &&
                            res.body.content.length > 0
                        ) {
                            this.bankMoviment = res.body.content;
                            this.onDataChanged.next(this.bankMoviment);
                        } else {
                            this.bankMoviment = res.body.content;
                        }
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
            });
        }*/

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
